<template>
  <div>
    <!-- Mobile -->
    <mq-layout :mq="['mobile', 'tablet']">
      <div class="marginMobile">
        <ul id="bar" class="NavBar-Container" v-if="displayBar()">
          <div v-if="route">
            <img src="@/assets/next.png" class="goBack-logo" @click="goBack()" />
          </div>
          <li>
            <router-link to="/" class="NavBar-Logo">
              <img src="@/assets/logo.png" max-width="100px" height="45px" />
            </router-link>
          </li>
          <li class="NavBar-Account active" v-cypress="$cypress.header.account">
            <div v-if="!display" @click="display = !display">
              <BurgerMenuIcon />
            </div>
            <div v-else class="NavBar-close" @click="display = false">
              <Close />
            </div>
          </li>
        </ul>

        <div v-if="display" class="slideMenu">
          <div class="bodySlide">
            <div
              class="text"
              @click="$router.push({ name: 'userAccountPersonnalInformation' }), (display = false)"
            >
              {{ $t('userAccount.myAccount') }}
            </div>
            <div
              class="text"
              @click="$router.push({ name: 'userAccountLanguage' }), (display = false)"
            >
              {{ $t('userAccount.language') }}
            </div>
            <div class="text" @click="logoutDrawer(), (display = false)">
              {{ $t('global.logout') }}
            </div>
            <div class="list-social-media">
              <div class="item-social-media" v-for="media in socialMedia" :key="media.id">
                <a :href="media.link" target="_blank">
                  <img :src="require(`@/assets/media_logo/${media.label}_logo.png`)" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mq-layout>

    <!-- desktop -->
    <mq-layout mq="desktop">
      <div class="NavBar-Container-Large">
        <img
          class="desktop-logo"
          src="@/assets/splash-logo.png"
          alt="icon"
          @click="$router.push('/')"
        />
        <!-- margin top -->
        <div id="index-gallery">
          <div v-if="this.$route.path == '/theme'" class="colorChangeSelection">
            <a class="item" v-on:click="$router.push('/theme')">
              <img src="@/assets/visite_noir.png" width="43%" />
              <p class="NavBar-Item-Text-Select">{{ $t('navBar.visit') }}</p>
            </a>
          </div>
          <div v-else class="colorChangeNotSelect">
            <a class="item" v-on:click="$router.push('/theme')">
              <img src="@/assets/logo visite.png" width="43%" />
              <p class="NavBar-Item-Text">{{ $t('navBar.visit') }}</p>
            </a>
          </div>

          <div v-if="this.$route.path == '/listTasting'" class="colorChangeSelection">
            <a class="item" v-on:click="$router.push('/listTasting')">
              <img src="@/assets/logo déguster active.png" class="backgroundSelect" width="56%" />
              <p class="NavBar-Item-Text-Select">{{ $t('navBar.taste') }}</p>
            </a>
          </div>
          <div v-else class="colorChangeNotSelect">
            <a class="item" v-on:click="$router.push('/listTasting')">
              <img src="@/assets/logo déguster.png" width="56%" />
              <p class="NavBar-Item-Text">{{ $t('navBar.taste') }}</p>
            </a>
          </div>

          <div v-if="this.$route.path == '/'" class="colorChangeSelection">
            <a class="item" v-on:click="$router.push('/')">
              <img src="@/assets/HomeActive.png" class="backgroundSelect" width="46%" />
              <p class="NavBar-Item-Text-Select">{{ $t('navBar.home') }}</p>
            </a>
          </div>
          <div v-else class="colorChangeNotSelect">
            <a class="item" v-on:click="$router.push('/')">
              <img src="@/assets/Home.png" width="46%" />
              <p class="NavBar-Item-Text">{{ $t('navBar.home') }}</p>
            </a>
          </div>
          <div v-if="this.$route.path == '/quiz'" class="colorChangeSelection">
            <a class="item" v-on:click="$router.push('/quiz')">
              <img src="@/assets/logo jeux active.png" class="backgroundSelect" width="46%" />
              <p class="NavBar-Item-Text-Select">{{ $t('navBar.games') }}</p>
            </a>
          </div>
          <div v-else class="colorChangeNotSelect">
            <a class="item" v-on:click="$router.push('/quiz')">
              <img src="@/assets/logo jeux.png" width="46%" />
              <p class="NavBar-Item-Text">{{ $t('navBar.games') }}</p>
            </a>
          </div>
          <div class="colorChangeNotSelect">
            <a class="item" style="text-decoration: none">
              <img @click="redirectToShop" src="@/assets/logo boutique.png" width="33%" />
              <p class="NavBar-Item-Text">{{ $t('navBar.shop') }}</p>
            </a>
          </div>
        </div>

        <img
          class="desktop-element"
          src="@/assets/logo menu.png"
          alt="icon"
          @click="display = !display"
        />
        <div v-if="display" class="slideMenuDesktop">
          <!-- <div :class="selectClass()" id="slide"> -->
          <div class="bodySlide">
            <div
              class="textDesktop"
              @click="$router.push({ name: 'userAccountPersonnalInformation' }), (display = false)"
            >
              {{ $t('userAccount.myAccount') }}
            </div>
            <div
              class="textDesktop"
              @click="$router.push({ name: 'userAccountLanguage' }), (display = false)"
            >
              {{ $t('userAccount.language') }}
            </div>
            <div class="textDesktop" @click="logoutDrawer(), (display = false)">
              {{ $t('global.logout') }}
            </div>
            <div class="list-social-media">
              <div class="item-social-media" v-for="media in socialMedia" :key="media.id">
                <a :href="media.link" target="_blank">
                  <img :src="require(`@/assets/media_logo/${media.label}_logo.png`)" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mq-layout>
  </div>
</template>

<script>
import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'
import BurgerMenuIcon from '@/components/layout/svg/BurgerMenuIcon'
import Close from '@/components/layout/svg/Close'
import remoteConfig from '@/lib/remote-config'

export default {
  name: 'Navbar',
  components: { Close, BurgerMenuIcon },
  mixins: [userMixin, remoteConfigMixin],
  data() {
    return {
      routes: [
        {
          route: '',
          label: this.$t('')
        }
      ],
      display: false
    }
  },
  computed: {
    route() {
      const routeName = this.$route.name
      if (routeName === 'home') {
        return false
      }
      return true
    },
    socialMedia() {
      if (remoteConfig.getValue('social_media')) {
        return JSON.parse(JSON.parse(JSON.stringify(remoteConfig.getValue('social_media'))))
      }
      return []
    }
  },
  methods: {
    displayBar() {
      return this.$route.name == 'splashScreen' ? false : true
    },
    selectIcon(routeName, name) {
      return this.actualRoute == routeName ? `${name}Active` : name
    },
    selectActive(routeName) {
      return this.actualRoute == routeName ? 'pageActive' : 'page'
    },
    ActiveClass(routeName) {
      return this.actualRoute == routeName ? 'boxItemsActive' : 'boxItems'
    },
    getImgUrl(icon) {
      if (!icon) return null

      const images = require.context('@/assets', false, /\.png$/)
      return images('./' + icon + '.png')
    },
    goBack() {
      const routeName = this.$route.name
      if (routeName == 'listTasting' || routeName == 'themeList' || routeName == 'quizList') {
        this.$router.push({ name: 'home' })
      } else {
        this.$router.back()
      }
    },
    openUserAccount() {
      if (this.isUserLogged) {
        this.$router.push('/useraccount')
      } else {
        this.$router.push('/login')
      }
    },
    logoutDrawer() {
      this.logout(() => {
        this.$router.push({ name: 'login' })
      })
      this.closeDrawer()
    },
    selectClass() {
      const div = document.getElementById('slide')
      if (this.display) {
        div.classList.remove('none')
      } else {
        div.classList.add('none')
      }
    },
    redirectToShop() {
      window.open(this.remoteConfig.getString('shop_url'), '_blank')
    }
  },

  mounted() {
    if (this.$mq == 'mobile') {
      const div = document.getElementById('bar')
      let lastScroll = 0
      window.addEventListener('scroll', () => {
        if (lastScroll < window.scrollY && window.scrollY > 100) div.classList.add('scroll')
        else if (lastScroll > window.scrollY) div.classList.remove('scroll')
        lastScroll = window.scrollY
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.marginMobile {
  margin-bottom: 70px;
}
.goBack-logo {
  height: 45px;
  width: 40px;
  align-content: center;
  transform: rotate(180deg);
  margin-left: 5px;
}
.backgroundSelect {
  background-color: #404040;
}
.colorChangeSelection {
  background-color: white;
  height: 90px;
  border-radius: 15px;
}
.colorChangeNotSelect {
  height: 90px;
}
.text {
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
}
.textDesktop {
  color: #ffffff;
  font: normal normal normal 50px/50px DM Sans, sans-serif;
  letter-spacing: 0px;
  color: #ffffff;
  cursor: pointer;
}
.bodySlide {
  display: flex;
  margin: 20px 20px 0 40px;
  flex-direction: column;
  height: calc(100% - 40px);
  justify-content: space-around;
}
.slideMenu {
  background-color: $primary;
  width: 100%;
  height: 200px;
  position: fixed;
  border-radius: 0 0 23px 23px;
  z-index: 10;
  top: 70px;
}
.slideMenuDesktop {
  background-color: $primary;
  width: 40%;
  height: 400px;
  position: fixed;
  border-radius: 0 0 23px 23px;
  z-index: 10;
  top: 90px;
  left: 60%;
  transition: left 1s;
}
.slideMenuDesktop.none {
  left: 100%;
}
.NavBar-Container {
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #ffffff;
  height: 70px;
  width: 100%;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14);
  justify-content: space-between;
  align-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  opacity: 1;
  transition: opacity 1s, height 0.25s;
  margin-bottom: 90px;
  z-index: 100;
}
.NavBar-Container.scroll {
  opacity: 0;
  height: 0;
}
li {
  float: left;
}

li a {
  display: block;
  color: black;
  text-align: center;
  text-decoration: none;
  height: 53px;

  &:hover {
    cursor: pointer;
  }
}
.active {
  background-color: $primary;
  // color: $primary;
}
.NavBar-Logo {
  margin-left: 25px;
  padding-top: 5px;
  vertical-align: middle;
}

.NavBar-Account {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 73px;
  height: 100%;
}
.NavBar-close {
  display: flex;
  height: 100%;
  width: 100%;
  line-height: 53px;
  align-items: center;
  justify-content: center;
  & svg {
    height: 24px;
    width: 24px;
  }
}
// Desktop - Tablet
.NavBar-Container-Large {
  z-index: 9;
  height: 90px;
  position: fixed;
  background-color: $primary;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  .desktop-logo {
    padding: 30px;
    cursor: pointer;
    height: 60%;
    width: auto;
    display: flex;
  }
  .desktop-element {
    margin: 25px;
    width: 3%;
    float: right;
    cursor: pointer;
  }
  .item {
    width: 80px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    align-items: center;
    padding-top: 13px;
    margin: 0px 15px;
  }
  #index-gallery {
    position: absolute;
    display: flex;
    justify-content: center;
    width: 60%;
    align-items: center;
    margin: 20%;
  }
  .NavBar-Item-Text {
    color: #ffffff;
  }
  .NavBar-Item-Text-Select {
    color: #404040;
  }
}

.qrcodeBtn1 {
  visibility: visible;
}

.qrcodeBtn2 {
  display: none;
}

.list-social-media {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: center;
  align-items: center;

  .item-social-media {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 10px;
    margin-right: 10px;
    @media screen and (max-width: 450px) {
      margin-left: 5px;
      margin-right: 5px;
    }
    img {
      width: 45px;
      height: 45px;
      @media screen and (max-width: 450px) {
        width: 25px;
        height: 25px;
      }
    }
  }
}
</style>
